import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OrganisationUI } from '@src/models';

@Component({
  selector: 'app-list-item-organisation',
  templateUrl: './list-item-organisation.component.html',
  styleUrls: ['../styles/list-item.component.scss', './list-item-organisation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemOrganisationComponent {
  @Input() data?: OrganisationUI;
}
